/** @format */

import { Customer } from './customer.interface';
import { ICart } from './cart/cart.interface';
import { KillSwitches } from './killswitch.interface';
import { LoyaltyBalance } from './loyalty-balance.interface';
import { MembershipStatusResponse } from './scorecard-membership.interface';
import { PersonalInformation } from './personal-information.interface';
import { StoredOffers, StoredRewards, StoredRewardsV4 } from './reward.interface';
import { StoredAthletePromo } from './athlete-promo.interface';
import { ProductSkuCatalogDetails } from './product-sku-catalog-details.interface';
import { CertonaRecommendations } from './certona-scheme.interface';
import { EDDv2, ModernEDD } from './cart-checkout/edd.model';

export interface BaseState {
  AUTHENTICATED?: boolean;
  CART?: ICart | null;
  CART_COUNT?: number;
  CART_PRODUCTS_SKU_CATALOG_DETAILS?: ProductSkuCatalogDetails[];
  CERTONA_RESPONSE?: CertonaRecommendations;
  CUSTOMER?: Customer;
  CUST_STORE?: string;
  DIRECT_ESTIMATED_DELIVERY?: EDDv2 | ModernEDD;
  ENVIRONMENT_KILLSWITCH_VALUES?: KillSwitches;
  KILLSWITCH_VALUES?: KillSwitches;
  LOYALTY_BALANCE?: LoyaltyBalance;
  PERSONAL_INFO?: PersonalInformation;
  MEMBERSHIP_STATUS?: MembershipStatusResponse;
  PRIMARY_CATEGORY?: unknown;
  PROMOS?: StoredAthletePromo;
  REWARDS?: StoredRewards;
  SAVEDPRODUCTS?: Map<string, string[]>;
  USER_SESSION_INVALID?: boolean;
  EXPRESS_CHECKOUT?: unknown;
  OFFERS?: StoredOffers;
  REWARDS_V4?: StoredRewardsV4;
}

export type IState<T extends object = object> = T & BaseState;
